import React from 'react';
import SQualityAssurance from '../../components/sQualityAssurance/QualityAssurance.jsx';
const sQualityAssurance = () => {
  return (
    <>
      {/* Footer Section  */}
      <section>
        <SQualityAssurance />
      </section>
    </>
  );
};

export default sQualityAssurance;
